module.exports = __webpack_public_path__ + "static/media/XP55-logo.c02c87fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/XP55/XP55-logo.svg
// module id = 530
// module chunks = 0